import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpErrorResponse,
  HttpClient,
  HttpParams,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { URL_PORTAL, URL_API, URL_ISLOGGED } from '../interfaces/constants';
import { AppService } from './app.service';
import { catchError, first, tap } from 'rxjs/operators';
import { ToastController } from '@ionic/angular';
import { AuthenticationService } from './authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private appService: AppService,
    private toastController: ToastController,
    private authService: AuthenticationService,
    private router: Router,
    private alertService: AlertService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}

  checkIfIsLogged(token: string) {
    let params = new HttpParams();
    params = params.append('token', token);
    this.http.get(URL_ISLOGGED, { params }).subscribe(
      (response: any) => {
        this.authService.createAuthUser(response);
          this.authService.setToken(
            response.username,
            response.token
          );
          this.router.navigateByUrl(`country-gateway`, {
            state: { isFromLoginPage: false },
          });
      },
      (error) => {
        this.alertService.alert('Falló la autenticación, por favor, vuelva a intentarlo.');
        this.authService.logout();
        this.router.navigateByUrl('/');
        this.authService.authNotifier.next(false);

      }
    );

  };

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes(URL_API) && this.appService.authUser) {
      let headers = new HttpHeaders();

      if (req.method === 'PATCH') {
        headers = headers.append('Content-Type', 'application/json-patch+json');
      }
      const token = localStorage.getItem('token');
      req = req.clone({
        headers: headers,
        setHeaders: {
          Authorization: `Basic ${token}`,
        },
      });
    }



    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500) {

          if (this.router.url.includes('country-gateway')){
            const token = this.route.snapshot.queryParams.token;
            this.checkIfIsLogged(token);
          }
        }
        if (error.status === 401) {
          this.alertService.alert('Ups, su sesión expiró');
          this.authService.logout();
          this.router.navigateByUrl('/');
          this.authService.authNotifier.next(false);
        }
        return throwError(error);
      })
    );
  }
}
